import React, { createContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export function AuthContextProvider(props) {
  const [auth, setAuth] = useState(() => {

    return JSON.parse(localStorage.getItem('auth')) || 0;
  });
  const [userId, setUserId] = useState(() => {
    // Initialize userId from localStorage or default to an empty string
    return localStorage.getItem('userId') || "";
  });

  useEffect(() => {
    localStorage.setItem('auth', JSON.stringify(auth));
    localStorage.setItem('userId', userId);
  }, [auth, userId]);

  function authTrue(value) {
    setAuth(value);
  }

  function authFalse() {
    setAuth(0);
    setUserId("");
  }

  function stowUserId(userId) {
    setUserId(userId);
  }

    

  const contextValue = {
    auth,
    userId,
    authTrue,
    authFalse,
    setUserId: stowUserId,
  };

  return (
    <AuthContext.Provider value={contextValue}>
      {props.children}
    </AuthContext.Provider>
  );
}

export default AuthContext;